export enum SimulationHistoricalPeriodType {
    VALUE = 1,
    RANGE = 2,
}
